import { render, staticRenderFns } from "./AllCourse.vue?vue&type=template&id=e5f632cc&scoped=true"
import script from "./AllCourse.vue?vue&type=script&lang=js"
export * from "./AllCourse.vue?vue&type=script&lang=js"
import style0 from "./AllCourse.vue?vue&type=style&index=0&id=e5f632cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f632cc",
  null
  
)

export default component.exports